<div [formGroup]="form" class="authentication-details">
  <app-common-checkbox
    [(ngModel)]="addAuthDetails"
    (ngModelChange)="onAddAuthenticationDetails($event)"
    [disabled]="isDisabled"
    [ngModelOptions]="{ standalone: true }"
    data-test-id="scan-auth-details-checkbox"
  >
    <span class="checkbox-label">{{ 'label_add_authentication_details' | translate }}</span>
  </app-common-checkbox>
  @if (addAuthDetails) {
    <div class="row margin-top margin-left">
      <div class="col-12 margin-bottom">
        <select
          [id]="scanCreateRequest.scanAuthenticationType"
          [formControlName]="scanCreateRequest.scanAuthenticationType"
          [attr.aria-label]="'select_scan_authentication_type_label' | translate"
        >
          @for (type of validAuthTypes; track $index) {
            <option [ngValue]="type">{{ 'scan_authentication_type_' + type | translate }}</option>
          }
        </select>
      </div>
      @if (
        defaultToSwa && form.get(scanCreateRequest.scanAuthenticationType).value === scanAuthenticationType.basic_authentication
      ) {
        <div class="col-12 margin-bottom">
          <ds-banner
            [state]="DsBannerState.warning"
            [showTitle]="true"
            [showCloseButton]="false"
            [showAction]="false"
            [title]="'scan_auth_basic_warning_title' | translate"
          >
            <div ds-banner-body>{{ 'scan_auth_basic_warning_body' | translate }}</div>
          </ds-banner>
        </div>
      }
      @switch (form.get(scanCreateRequest.scanAuthenticationType).value) {
        @case (scanAuthenticationType.basic_authentication) {
          <app-common-input
            [form]="form"
            [context]="getInputFieldContext(scanCreateRequest.scanAuthenticationUserName)"
            [formValidationRequest$]="formValidationRequest$"
            class="col-12 col-xl-6 margin-bottom"
          >
          </app-common-input>
          <app-common-input
            [form]="form"
            [context]="getInputFieldContext(scanCreateRequest.scanAuthenticationPassword)"
            [formValidationRequest$]="formValidationRequest$"
            class="col-12 col-xl-6 margin-bottom"
          >
          </app-common-input>
        }
        @case (scanAuthenticationType.secure_web_authentication) {
          <app-common-input
            [form]="form"
            [formValidationRequest$]="formValidationRequest$"
            class="col-12 margin-bottom"
            [context]="getInputFieldContext(scanCreateRequest.swaLoginPageURL)"
          ></app-common-input>
          <app-common-input
            [form]="form"
            [formValidationRequest$]="formValidationRequest$"
            class="col-12 col-xl-6 margin-bottom"
            [context]="getInputFieldContext(scanCreateRequest.swaUserName)"
          ></app-common-input>
          <app-common-input
            [form]="form"
            [formValidationRequest$]="formValidationRequest$"
            class="col-12 col-xl-6 margin-bottom"
            [context]="getInputFieldContext(scanCreateRequest.swaUserNameFieldId)"
          ></app-common-input>
          <app-common-input
            [form]="form"
            [formValidationRequest$]="formValidationRequest$"
            class="col-12 col-xl-6 margin-bottom"
            [context]="getInputFieldContext(scanCreateRequest.swaSubmitUsernameFieldId)"
          ></app-common-input>
          <div class="col-12 col-xl-6" aria-hidden="true"></div>
          <app-common-input
            [form]="form"
            [formValidationRequest$]="formValidationRequest$"
            class="col-12 col-xl-6 margin-bottom"
            [context]="getInputFieldContext(scanCreateRequest.swaPassword)"
          ></app-common-input>
          <app-common-input
            [form]="form"
            [formValidationRequest$]="formValidationRequest$"
            class="col-12 col-xl-6 margin-bottom"
            [context]="getInputFieldContext(scanCreateRequest.swaPasswordFieldId)"
          ></app-common-input>
          <app-common-input
            [form]="form"
            [formValidationRequest$]="formValidationRequest$"
            class="col-12 col-xl-6 margin-bottom"
            [context]="getInputFieldContext(scanCreateRequest.swaSubmitFieldId)"
          ></app-common-input>
          <app-common-input
            [form]="form"
            [formValidationRequest$]="formValidationRequest$"
            class="col-12 col-xl-6 margin-bottom"
            [context]="getInputFieldContext(scanCreateRequest.swaSubmitSuccessId)"
          ></app-common-input>
        }
      }
    </div>
  }
</div>
